var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsericon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.241,
    height: 55.116,
    viewBox: "0 0 55.241 55.116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M196.62,543.648H141.711a4.931,4.931,0,0,1,2.365-5.993,33.767,33.767,0,0,1,9.844-3.642c.765-.187,1.539-.355,2.319-.466a6.908,6.908,0,0,0,4.662-2.823,22.232,22.232,0,0,0,1.7-2.611c.863-1.555.831-1.569-.476-2.743a25.406,25.406,0,0,1-5.7-8.409,8.887,8.887,0,0,0-1.021-1.617,8.12,8.12,0,0,1-1.766-5.3c.04-1.512.542-2.135,1.8-2.5-.112-1.97-.278-3.931-.326-5.9-.213-8.587,6.022-12.27,11.7-12.962a16.093,16.093,0,0,1,11.219,2.4,11.007,11.007,0,0,1,5.067,9.365c.059,2.143-.211,4.293-.331,6.441-.012.21,0,.421,0,.626a2.316,2.316,0,0,1,1.858,2.626,8.174,8.174,0,0,1-1.841,5.28,7.267,7.267,0,0,0-.913,1.434c-1.625,3.471-3.459,6.782-6.563,9.2a.922.922,0,0,0-.2.872,49.98,49.98,0,0,0,3.209,4.8c.946,1.18,2.439,1.489,3.9,1.868,3.253.846,6.46,1.87,9.674,2.857a8.5,8.5,0,0,1,1.54.76C196.346,538.831,197,540.131,196.62,543.648Z",
    transform: "translate(-141.477 -488.531)",
    fill: "#c6d6ff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsericon);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/user.icon.e43181e22dbb9ee081a5b56971ada850.svg";
export { ForwardRef as ReactComponent };